<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-01-10 13:51:56
-->
<template>
  <!-- 育苗 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div class="type-activite">年度经营目标完成情况</div>
      </div>
      <!-- 年度目标完成情况汇总表-育苗 -->
      <SummaryPage v-if="pageType === 'summary'" @getPageType="getPageType" />
      <!-- 年度目标完成情况明细表-育苗 -->
      <DetailPage v-if="pageType === 'detail'" @getPageType="getPageType" />
    </div>
  </div>
</template>

<script>
import SummaryPage from "./summary-page.vue";
import DetailPage from "./detail-page.vue";
export default {
  name: "ym",
  data() {
    return {
      pageType: "summary", // summary汇总表,detail明细表
    };
  },
  computed: {},
  methods: {
    getPageType(pageType) {
      this.pageType = pageType;
    },
  },
  components: {
    SummaryPage,
    DetailPage,
  },
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {},
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    // keyName: {
    // 注意：当观察的数据为对象或数组时，curVal和oldVal是相等的，因为这两个形参指向的是同一个数据对象
    // deep: true,
    //handler (curVal, oldVal) {
    // console.log(curVal, oldVal)
    //}
    // }
  },
};
</script>

<style lang="less" scoped>
</style>